import {Component, OnInit} from '@angular/core';
import {HeaderComponent} from "../header/header.component";
import {FooterComponent} from "../footer/footer.component";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {ErrorDTO} from "../dto/error-dto";

@Component({
  selector: 'app-error',
  standalone: true,
    imports: [
        HeaderComponent,
        FooterComponent
    ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent implements OnInit {

  constructor(private router: Router, private alert: ToastrService) {
    let error = <ErrorDTO>router.getCurrentNavigation().extras.state;
    if (error?.message) {
      let message=  error.message.includes(":") ? error.message.split(":")[1] : error.message;
      this.alert.error(message, '')
    }
  }

  ngOnInit(): void {
    let key = localStorage.getItem("cp-key");
    let hash = localStorage.getItem("cp-hash");
    if (key && hash) {
      localStorage.removeItem("cp-key");
      localStorage.removeItem("cp-hash");
      this.router.navigate(['/'], {
        queryParams: { key: key, hash: hash },
      })
    }
    }

}
